import {
  getCurrentUserRole as getCurrentUserRoleFromRbac,
  hasPermission,
  normalizeRoleInput,
  parseRole,
  Permission,
} from "./rbac";

export const getCurrentUserRole = ()=> {
  const role = getCurrentUserRoleFromRbac();
  return role ?? "";
};

export const normalizeRole = (role) => normalizeRoleInput(role);

export const hasAnyRole = (role, allowedRoles) => {
  const parsedRole = parseRole(role);
  if (!parsedRole) return false;

  return allowedRoles.some((allowedRole) => parseRole(allowedRole) === parsedRole);
};

export const canManageProjectReviewItems = (role)=>
  hasPermission(role, Permission.REVIEW_EDIT);
